export const round = (value, precision = 4) => Math.round(value * 10 ** precision) / 10 ** precision

const getDiscountBarcode = desc => {
  if (typeof desc !== 'string') return null
  const match = desc.trim().match(/^desconto\s+(.+)$/i)
  return match ? match[1].trim() : null
}

export const expandRowsBySerial = rows => rows.reduce((res, { Matricola: serials, Quantita, ...row }) => {
  if (Array.isArray(serials)) for (const Matricola of serials) res.push({ Matricola, Quantita: 1, ...row })
  else res.push({ Matricola: serials, Quantita, ...row })
  return res
}, [])

export const groupRows = (rows, keyBy) => rows.reduce((res, { PK, Matricola, ...row }) => {
  const discountBarcode = getDiscountBarcode(row.Descrizione)
  const item = res.rows.find(v => {
    const itemDiscountBarcode = getDiscountBarcode(v.Descrizione)
    if (discountBarcode && itemDiscountBarcode) return itemDiscountBarcode === discountBarcode
    return keyBy.reduce((isEqual, field) => isEqual && (v[field] === row[field]), true)
  })

  if (!item || (Matricola && !item.Matricola) || (item.Matricola && !Matricola)) res.rows.push({ Matricola, PK, ...row })
  else {
    if (discountBarcode && getDiscountBarcode(item.Descrizione) === discountBarcode) item.price = round((Number(item.price) || 0) + (Number(row.price) || 0))
    else item.Quantita += row.Quantita
    item.qty_max += row.qty_max
    if (Matricola) {
      if (Array.isArray(item.Matricola)) item.Matricola.push(Matricola)
      else item.Matricola = [item.Matricola, Matricola]
      if (Array.isArray(item.PK)) item.PK.push(PK)
      else item.PK = [item.PK, PK]
    } else res.PKs.push(PK)
  }
  return res
}, { rows: [], PKs: [] })

export const expandRows = rows => rows.reduce((res, { PK, Matricola: serials, Quantita, ...row }) => {
  if (!PK) {
    if (Array.isArray(serials)) for (const Matricola of serials) res.push({ Matricola, Quantita: 1, ...row })
    else res.push({ Matricola: serials, Quantita, ...row })
  } else {
    if (Array.isArray(PK)) {
      if (Array.isArray(serials)) for (const [idx, Matricola] of serials.entries()) res.push({ PK: PK[idx], Matricola, Quantita: 1, ...row })
      else throw new Error('Anomalia righe')
    } else {
      if (Array.isArray(serials)) {
        const [first, ...rest] = serials
        res.push({ PK, Matricola: first, Quantita: 1, ...row })
        for (const Matricola of rest) res.push({ Matricola, Quantita: 1, ...row })
      // } else if (row.Audx && row.Ausx && Quantita % 2 === 0) {
      //   res.push({ PK, Matricola: serials, Quantita: 1, ...row, Audx: true, Ausx: false })
      //   while (Quantita > 1) {
      //     res.push({ Matricola: serials, Quantita: 1, ...row, Ausx: true, Audx: false })
      //     Quantita--
      //   }
      } else res.push({ PK, Matricola: serials, Quantita, ...row })
    }
  }
  return res
}, []).sort((a, b) => (a.PK === undefined || a.PK > b.PK) ? 1 : -1)
